var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbCakeDob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-cake-dob_svg__clip0_1272_2411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 19.167a.833.833 0 01-.833.833H.833a.833.833 0 110-1.667h18.334a.833.833 0 01.833.834zM3.125 12.5c.89 0 1.458-.547 1.458-.833a.833.833 0 011.667 0c0 .255.55.833 1.458.833.89 0 1.459-.547 1.459-.833a.833.833 0 011.666 0c0 .255.551.833 1.459.833.89 0 1.458-.547 1.458-.833a.833.833 0 011.667 0c0 .255.55.833 1.458.833.907 0 1.458-.578 1.458-.833A4.172 4.172 0 0014.167 7.5h-3.334V5.68A2.5 2.5 0 0012.5 3.333 5.569 5.569 0 0011.11.492a1.547 1.547 0 00-2.22 0A5.563 5.563 0 007.5 3.333 2.5 2.5 0 009.167 5.68V7.5H5.833a4.172 4.172 0 00-4.166 4.167c0 .255.55.833 1.458.833zM2.5 16.667h15a.834.834 0 00.833-.834v-1.979c-.459.204-.955.31-1.458.313a3.495 3.495 0 01-2.292-.834 3.59 3.59 0 01-4.583.013 3.59 3.59 0 01-4.583-.013c-.64.544-1.453.84-2.292.834-.502-.002-1-.109-1.458-.313v1.98a.833.833 0 00.833.833z",
    fill: "#1C1D1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-cake-dob_svg__clip0_1272_2411"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgIbCakeDob;